var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"待办件"}},[_c('order-workbench',{attrs:{"show-title":false,"extra-query-params":{ todo_list: 1 },"auto-column-width":true}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a88f14f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/TodoList.vue
// module id = cIcS
// module chunks = 0